import CONSTANT from '../../constants'
import fetchWithAuthorizationHeader from '../../helper/fetchWithAuthorizationHeader'
import type { TagDetailOption } from './getTagDetails'

// PATCH appends a value; DELETE removes an exact match.
const modifyTagDetailValue = async (
	method: 'PATCH' | 'DELETE',
	tagDetailName: string,
	tagDetailValue: TagDetailOption
): Promise<void> => {
	const response = await fetchWithAuthorizationHeader(
		`${CONSTANT.TAG_DETAILS_API_URL}?tagDetailName=${encodeURIComponent(
			tagDetailName
		)}`,
		{
			method,
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ tagDetailName, tagDetailValue })
		}
	)

	if (response.ok) return
	if (response.status === 403) {
		throw new Error(
			method === 'DELETE'
				? 'Not authorized to delete platforms (requires tag-details:*:delete).'
				: 'Not authorized to add platforms (PATCH /tag-details was refused).'
		)
	}
	if (response.status === 422) {
		throw new Error(
			method === 'DELETE'
				? 'This value no longer exists.'
				: 'This value could not be added.'
		)
	}
	throw new Error('Request failed. Try again.')
}

export default modifyTagDetailValue
